import React, { useState, useEffect } from 'react';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import { NavLogo } from './Logo';

const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.pageYOffset > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 bg-navy-900/90 backdrop-blur-md border-b border-gold-500/15 ${
        scrolled ? 'shadow-lg py-2' : 'py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo/Brand */}
        <HashLink to="/#hero" smooth className="flex-shrink-0">
          <NavLogo />
        </HashLink>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          <HashLink
            to="/#services"
            smooth
            className="font-sans text-base font-medium tracking-wide text-cream-200 hover:text-gold-400 transition-colors duration-300"
          >
            Services
          </HashLink>
          <HashLink
            to="/#about"
            smooth
            className="font-sans text-base font-medium tracking-wide text-cream-200 hover:text-gold-400 transition-colors duration-300"
          >
            About
          </HashLink>
          <Link
            to="/contact"
            className="font-sans text-sm font-semibold tracking-[0.15em] px-6 py-2.5 border border-gold-500/50 text-gold-400 hover:bg-gold-400/10 transition-all duration-300"
          >
            CONTACT
          </Link>
        </div>

        {/* Mobile menu button */}
        <button
          className="md:hidden p-2"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          <svg
            className="w-6 h-6 text-gold-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {isOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          isOpen ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-navy-900/95 backdrop-blur-md px-6 py-4 space-y-3 border-t border-gold-500/10">
          <HashLink
            to="/#services"
            smooth
            className="block font-sans text-sm text-cream-200 hover:text-gold-400 transition-colors"
            onClick={() => setIsOpen(false)}
          >
            Services
          </HashLink>
          <HashLink
            to="/#about"
            smooth
            className="block font-sans text-sm text-cream-200 hover:text-gold-400 transition-colors"
            onClick={() => setIsOpen(false)}
          >
            About
          </HashLink>
          <Link
            to="/contact"
            className="block font-sans text-sm text-gold-400 font-semibold tracking-wide"
            onClick={() => setIsOpen(false)}
          >
            CONTACT
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
